import { memo } from 'react';
import { Page } from '@betty/navigation';
import { Box, ScrollView } from '@betty/moonlight';
import FreeSpinsSection from '../components/FreeSpinsSection/FreeSpinsSection';
import DailyGiftSection from '../components/DailyGiftSection/DailyGiftSection';
import WheelSpinSection from '../components/WheelSpinSection/WheelSpinSection';

function RewardsPage() {
  return (
    <Page>
      <ScrollView
        contentContainerStyle={{
          width: '100%',
          maxWidth: 'max-page-width',
          marginHorizontal: 'auto',
        }}
      >
        <FreeSpinsSection />
        <Box flexDirection="row" flexWrap="wrap" justifyContent="center">
          <Box width={{ mobile: '100%', tablet: '70%', desktop: '50%' }}>
            <DailyGiftSection />
          </Box>
          <Box width={{ mobile: '100%', tablet: '70%', desktop: '50%' }}>
            <WheelSpinSection />
          </Box>
        </Box>
      </ScrollView>
    </Page>
  );
}

export default memo(RewardsPage);
